import React from 'react';
import { Wordmark } from './BrandArtwork';
import { FooterCatVignette } from './FooterCatVignette';
import { navLinks } from '../data/site';
export function SiteFooter() {
  return <footer className="relative min-h-[620px] overflow-hidden border-t border-ink/10 bg-cream md:min-h-[640px] lg:min-h-[660px]" data-id="element-127" data-mp="3mh9i07pj8jg1">
      <FooterCatVignette data-id="element-128" data-mp="3hherw6dkzxw1" />

      <div className="relative z-10 mx-auto flex min-h-[620px] max-w-content flex-col px-5 pb-8 pt-16 md:min-h-[640px] md:px-8 lg:min-h-[660px] lg:px-10" data-id="element-129" data-mp="3hi6bsjxtg76h">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12" data-id="element-130" data-mp="38h8eekhvuxwv">
          <div className="md:col-span-6" data-id="element-131" data-mp="38k4eaedajwny">
            <Wordmark className="h-8 w-auto md:h-10" knockoutId="footer-wordmark-knockout" data-id="element-132" data-mp="33jq52szyegoc" />
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ink/75" data-id="element-133" data-mp="2ykdkyg0gvnpg">
              A boutique app studio building original apps for learning, life and play.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-6 md:grid-cols-2" data-id="element-134" data-mp="wrz1hci9yb6x">
            <nav aria-label="Footer" data-id="element-135" data-mp="15qc1ygh1hjh0">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-136" data-mp="15padnab0j0hc">
                Sections
              </h2>
              <ul className="mt-4 space-y-1" data-id="element-137" data-mp="1anlqzv0int4b">
                {navLinks.map(link => <li key={link.href} data-id="element-138" data-mp="vv1z5qith826">
                    <a href={link.href} className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-139" data-mp="10qz4l1sjku06">
                      {link.label}
                    </a>
                  </li>)}
                <li data-id="element-140" data-mp="1er0et7up5dsb">
                  <a href="#top" className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-141" data-mp="1eppddeoq4i4d">
                    Back to top
                  </a>
                </li>
              </ul>
            </nav>

            <div data-id="element-142" data-mp="2m3fv5qhyt6yi">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-143" data-mp="2m1uynvc3bdy0">
                Studio
              </h2>
              <ul className="mt-4 space-y-3 text-[15px] text-ink/80" data-id="element-144" data-mp="2h1qhe33cyf6q">
                <li data-id="element-145" data-mp="2d0wsp7i3cwcs">blackcometlabs.io</li>
                <li data-id="element-146" data-mp="2d42lawpxigd9">Learning · Lifestyle · Gaming</li>
                <li data-id="element-147" data-mp="282d5z4vobgjd">Built for U.S. users</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-20" data-id="element-148" data-mp="235mr2kvluqzj">
          <p className="pr-16 pt-5 text-xs font-medium text-ink/65" data-id="element-149" data-mp="1ydbqrgwyd36g">
            © {new Date().getFullYear()} Black Comet Labs. Small studio. Serious apps.
          </p>
        </div>
      </div>
    </footer>;
}